/**
 * Converts a given flag emoji string into its corresponding country code.
 *
 * This function takes an emoji flag, converts its Unicode code points to the corresponding
 * country code, then converts it to lowercase.
 *
 * @param {string} flag - The flag emoji to be converted into a country code.
 * @returns {string} The two-letter country code in lowercase, or '' when there is no flag.
 *
 * @example
 * Returns 'gr' for the Greek flag emoji 🇬🇷
 * emojiFlagToCountryCode('🇬🇷');
 */
export const emojiFlagToCountryCode = (flag: string | undefined): string => {
  if (!flag) {
    return '';
  }

  // This is a special case for the Welsh flag emoji.
  // It is a subdivision flag with a complex Unicode sequence.
  if (flag === '🏴󠁧󠁢󠁷󠁬󠁳󠁿') {
    return 'gb-wls';
  }

  return Array.from(flag, (codeUnit) => codeUnit.codePointAt(0) ?? 0)
    .map((char) => String.fromCharCode(char - 127397).toLowerCase())
    .join('');
};
